
if (!customElements.get('benefit-card-set')) {
  customElements.define('benefit-card-set', class BenefitCardSet extends HTMLElement {
    constructor() {
      super();

      const grid = this.querySelector(".benefit-cards-section__cards");
      const dots = this.querySelectorAll(".benefit-cards-section__dot");
      const cards = grid?.querySelectorAll('benefit-card');

      if (grid && dots.length && cards.length) {
        grid.addEventListener('scroll', () => {
          const scrollLeft = grid.scrollLeft;
          const gridCenter = grid.offsetWidth / 2;
          const cardWidth  = grid.scrollWidth / cards.length;
          let active       = Math.floor((scrollLeft + gridCenter) / cardWidth);
          if (scrollLeft === 0) {
            active = 0;
          } else if (scrollLeft >= grid.scrollWidth - grid.offsetWidth) {
            active = cards.length - 1;
          }
          dots.forEach((d, i) => d.classList.toggle('active', i === active));
        }, { passive: true });

        dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            const gridCenter = grid.offsetWidth / 2;
            const cardWidth  = grid.scrollWidth / cards.length;
            let scrollLeft = (index + .5) * cardWidth - gridCenter;
            if (scrollLeft < 0) {
              scrollLeft = 0;
            } else if (scrollLeft > grid.scrollWidth - grid.offsetWidth) {
              scrollLeft = grid.scrollWidth - grid.offsetWidth;
            }
            grid.scrollTo({
              left: Math.round(scrollLeft),
              behavior: 'smooth'
            });
          });
        });
      }
    }
  });
}

if (!customElements.get('benefit-card')) {
  customElements.define('benefit-card', class BenefitCard extends HTMLElement {
    constructor() {
      super();

      this.benefitCardFront = this.querySelector(".benefit-card-front");
      this.benefitCardBack = this.querySelector(".benefit-card-back");
      this.learnMorePromptAction = this.querySelector(".benefit-card__learn-more-prompt-action");
      this.cardFlippable = this.dataset.cardFlippable;

      // Click and enter/space to flip the card
      if (this.cardFlippable) {
        this.addEventListener("click", () => {
          this.toggle();
        });
        this.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.toggle();
          }
        });
      }

      // Change the learn more prompt action to 'Tap' on mobile
      const mobileQuery = window.matchMedia('(hover: none) and (pointer: coarse)');
      if (this.learnMorePromptAction) {
        mobileQuery.addEventListener('change', (event) => {
          this.learnMorePromptAction.textContent = event.matches ? 'Tap' : 'Hover';
        });
      }
    }

    toggle() {
      this.classList.toggle("flipped");
    }
  });
}
